import { IInputCreateLeads } from "src/Contexts/Leads/LeadsTypes";

export const valuesDefaultInputsLandingPages: IInputCreateLeads = {
  name: "",
  whats: "",
  email: "",
  cpf: "",
  entityType: " ",
  isPlan: "NOT",
  descriptionPlan: "",
  sourceCollection: "LADING_PAGE",
  status: "NEW",
  interestLevel: "HIGH",
  telefone1: "",
  observation: "",
  birthDate: "",
  captureAt: "",
  reasonAbandonment: "",
};
